import { FIND_FILE_REFERENCE_REQUEST, findFileReferenceSuccess, findFileReferenceFailure } from 'Redux/Action';
import { ofType }                                                                          from 'redux-observable';
import { from, EMPTY }                                                                     from 'rxjs';
import { mergeMap }                                                                        from 'rxjs/operators';
import { TEpic }                                                                           from 'Redux/Config';

export const findFileReferenceEpic: TEpic = (action$, store$, { FileReferenceRepository }) => {
  return action$.pipe(
    ofType(FIND_FILE_REFERENCE_REQUEST),
    mergeMap(action => {
      const { id } = action.payload;

      if (!id.trim()) {
        return EMPTY;
      }

      return from(
        FileReferenceRepository.findById(id)
          .then(fileReference => findFileReferenceSuccess(fileReference))
          .catch(error => findFileReferenceFailure(error)),
      );
    }),
  );
};
